export enum ReportDataType {
    amount = 'amount',
    percent = 'percent',
    number = 'number',
    fte = 'fte'
}
